export default __webpack_public_path__ + "static/media/asphaltFront3.cea617c4.png";